var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrengthsLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25.121,
    height: 12.737,
    viewBox: "0 0 25.121 12.737",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_828",
    "data-name": "Rectangle 828",
    width: 25.121,
    height: 12.737,
    fill: "#ebf8ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_736",
    "data-name": "Group 736",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_619",
    "data-name": "Group 619",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5376",
    "data-name": "Path 5376",
    d: "M24.762,2.755a1.459,1.459,0,0,0-.894-.413H21.54v-.82A1.542,1.542,0,0,0,20.018,0h-1.67a1.543,1.543,0,0,0-1.522,1.522V4.093H8.321V1.522A1.542,1.542,0,0,0,6.8,0H5.129A1.5,1.5,0,0,0,3.607,1.522V2.4H1.279A1.242,1.242,0,0,0,.053,3.621L0,9.18a1.348,1.348,0,0,0,.385.856,1.458,1.458,0,0,0,.894.413H3.607v.766A1.581,1.581,0,0,0,4.047,12.3a1.5,1.5,0,0,0,1.083.44H6.8a1.542,1.542,0,0,0,1.522-1.522V8.59h8.506v2.624a1.582,1.582,0,0,0,.44,1.083,1.5,1.5,0,0,0,1.082.44h1.67a1.5,1.5,0,0,0,1.522-1.522v-.767h2.34a1.346,1.346,0,0,0,.856-.385,1.269,1.269,0,0,0,.386-.867V3.649a1.218,1.218,0,0,0-.359-.894M24.15,9.169a.247.247,0,0,1-.255.255H21.54V3.34h2.329a.294.294,0,0,1,.183.072.213.213,0,0,1,.078.145l-.006.019Zm-6.327-7.6a.454.454,0,0,1,.123-.345.547.547,0,0,1,.4-.17h1.67a.585.585,0,0,1,.371.153.481.481,0,0,1,.153.372v1.1a.523.523,0,0,0,0,.329v8.273a.454.454,0,0,1-.123.345.547.547,0,0,1-.4.17H18.339a.458.458,0,0,1-.345-.123.548.548,0,0,1-.17-.4Zm-1,6.026H8.321V5.09h8.506ZM4.605,2.73V1.576A.507.507,0,0,1,4.758,1.2a.583.583,0,0,1,.371-.153H6.8A.584.584,0,0,1,7.17,1.2a.482.482,0,0,1,.153.372v9.7a.453.453,0,0,1-.123.345.546.546,0,0,1-.4.17H5.12a.455.455,0,0,1-.345-.123.547.547,0,0,1-.17-.4V3.06a.523.523,0,0,0,0-.331m-3.581.919a.247.247,0,0,1,.255-.255H3.607V9.451H1.279A.247.247,0,0,1,1.024,9.2Z",
    transform: "translate(0 0)",
    fill: "#ebf8ff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrengthsLight);
export default __webpack_public_path__ + "static/media/strengths_light.8feb72da56f7a5d8f1ccc637c4957d1c.svg";
export { ForwardRef as ReactComponent };